/* eslint import/prefer-default-export: 0 */
import moment from 'moment'

import axios from '../utils/api'
import CONFIG from '../config'
import { LIST_EVENTS_REQUEST, LIST_EVENTS_RESPONSE, LIST_EVENTS_RESPONSE_ERROR } from '../constants'

function getLoaderId(action) {
  if (action.timeseriesId) {
    return action.timeseriesId
  }
  return ''
}

function fetchEvents(dispatch, timeseriesId, params) {
  axios.get(
    `${CONFIG.apiBase}/timeseries/${timeseriesId}/events`,
    { params },
  ).then((response) => {
    dispatch({
      type: LIST_EVENTS_RESPONSE,
      timeseriesId,
      getLoaderId,
      events: response.data.body,
    })
  }).catch((error) => {
    // TODO: error handling
    // console.log(error);
    dispatch({
      type: LIST_EVENTS_RESPONSE_ERROR,
      error,
      timeseriesId,
      getLoaderId,
      events: [],
    })
  })
}

// TODO: figure out what to do about the blank from/to
export function listEvents(timeseriesId, from = moment().subtract(1, 'day'), to = moment()) {
  const tsId = parseInt(timeseriesId, 10)
  return (dispatch) => {
    dispatch({
      type: LIST_EVENTS_REQUEST,
      timeseriesId: tsId,
      getLoaderId,
    })

    fetchEvents(dispatch, tsId, { from: from.unix(), to: to.unix() })
  }
}

export function listSparseEvents(timeseriesId, limit) {
  const tsId = parseInt(timeseriesId, 10)
  return (dispatch) => {
    dispatch({
      type: LIST_EVENTS_REQUEST,
      timeseriesId: tsId,
      getLoaderId,
    })

    fetchEvents(dispatch, tsId, { from: 1, limit })
  }
}
